import React from 'react';
import { FormField } from '../FormField';
import { AnvilSelect, } from '../AnvilSelect';
export const FormAnvilSelect = React.forwardRef((props, ref) => {
    return (React.createElement(FormField, Object.assign({ control: AnvilSelect, className: "a-Select--Form" }, props, { ref: ref })));
});
//# sourceMappingURL=FormAnvilSelect.js.map